// 회원가입 유입경로 — 앱(comministermore/src/login/signupSource.ts)과 목록을 맞춰 둘 것
export const SIGNUP_SOURCE_OPTIONS = [
  '인터넷 검색(네이버·구글)',
  '지인·동료 추천',
  '포스터·전단지',
  '교회·교단 소개',
  'SNS(인스타그램·유튜브 등)',
  '사역자모아 안내 메일',
  '앱스토어·플레이스토어',
] as const;

export const SIGNUP_SOURCE_ETC = '기타';

/** 서버에 저장할 값 — 기타는 "기타: 직접입력" */
export function buildSignupSource(selected: string, etcText: string): string {
  if (selected !== SIGNUP_SOURCE_ETC) return selected;
  const text = etcText.trim();
  return text ? `${SIGNUP_SOURCE_ETC}: ${text}` : SIGNUP_SOURCE_ETC;
}
